module.exports = __webpack_public_path__ + "media/application/images/icons/topics-processing-pebble-dark-green-rgb-f19e66b3c6dbeacb763bcb54a2b5208e.svg";